import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drv-form-root drv-base-account-name" }
const _hoisted_2 = { class: "drv-text-body-md drv-text-weight-medium" }
const _hoisted_3 = ["innerHTML"]

import HelpLink from "../HelpLink.vue";
import { computed, ref } from "vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  EPlatformName,
  IBaseAccountName,
  EAuthTypes,
  ECommonMessages,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import {
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseAccountName',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit =
  __emit;

const icon = {
  name: "circle-information",
  size: 16,
};

const EMPTY_MODEL = {
  type: EAuthTypes.ACCOUNT,
  agree: false,
  account_name: "",
};

const model = computed<IBaseAccountName>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: IBaseAccountName) {
    emit("update:modelValue", value);
  },
});

const agreeModel = computed<boolean>({
  get() {
    return props.modelValue?.agree ?? EMPTY_MODEL.agree;
  },
  set(value: boolean) {
    model.value = { ...model.value, agree: value };
  },
});

const accountNameModel = computed<string>({
  get() {
    return props.modelValue?.account_name ?? EMPTY_MODEL.account_name;
  },
  set(value: string) {
    model.value = { ...model.value, account_name: value };
  },
});

const textByPlatformName: Partial<
  Record<EPlatformName, { url: string; hint?: string; fieldName: string }>
> = {
  [EPlatformName.WEBFLEET]: {
    url: ETelematicsMessagesKeys.WEBFLEET_INSTRUCTIONS_URL,
    hint: ETelematicsMessagesKeys.WEBFLEET_ACCOUNT_NAME_HINT,
    fieldName: ETelematicsMessagesKeys.BASE_ACCOUNT_NAME_FIELD_TITLE,
  },
  [EPlatformName.FLEET_COMPLETE]: {
    url: ETelematicsMessagesKeys.FLEET_COMPLETE_INSTRUCTIONS_URL,
    hint: ETelematicsMessagesKeys.FLEET_COMPLETE_ACCOUNT_NAME_HINT,
    fieldName: ETelematicsMessagesKeys.FLEET_COMPLETE_ACCOUNT_NAME_FIELD_TITLE,
  },
  [EPlatformName.TELUS]: {
    url: ETelematicsMessagesKeys.TELUS_INSTRUCTIONS_URL,
    hint: ETelematicsMessagesKeys.TELUS_ACCOUNT_NAME_HINT,
    fieldName: ETelematicsMessagesKeys.TELUS_ACCOUNT_NAME_FIELD_TITLE,
  },
  [EPlatformName.BIGROAD]: {
    url: ETelematicsMessagesKeys.BIGROAD_INSTRUCTIONS_URL,
    hint: ETelematicsMessagesKeys.BIGROAD_ACCOUNT_NAME_HINT,
    fieldName: ETelematicsMessagesKeys.BIGROAD_ACCOUNT_NAME_FIELD_TITLE,
  },
  [EPlatformName.ATNT_FLEET_COMPLETE]: {
    url: ETelematicsMessagesKeys.ATNT_FLEET_COMPLETE_INSTRUCTIONS_URL,
    hint: ETelematicsMessagesKeys.ATNT_FLEET_COMPLETE_ACCOUNT_NAME_HINT,
    fieldName: ETelematicsMessagesKeys.BASE_ACCOUNT_NAME_FIELD_TITLE,
  },
};

const currentText = computed<{
  url: string;
  hint?: string;
  fieldName: string;
}>(() => {
  return (
    textByPlatformName[props.platform.const] ?? {
      url: "",
      fieldName: ETelematicsMessagesKeys.BASE_ACCOUNT_NAME_FIELD_TITLE,
    }
  );
});

const nameControl = ref<typeof Input | null>(null);
const hasError = computed<boolean>(() => {
  return (
    !accountNameModel.value || nameControl.value?.hasError || !agreeModel.value
  );
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_checkbox = _resolveComponent("d-checkbox")!
  const _component_d_icon_tooltip = _resolveComponent("d-icon-tooltip")!
  const _component_d_input = _resolveComponent("d-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).BASE_ACCOUNT_NAME_INSTRUCTION_1_TITLE, {
            name: _ctx.platform.label,
          })), 1),
      _createVNode(HelpLink, {
        link: _ctx.$t(currentText.value.url)
      }, null, 8, ["link"])
    ]),
    _createVNode(_component_d_checkbox, {
      class: "drv-embeded-checkbox drv-form-control-adaptive",
      modelValue: agreeModel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((agreeModel).value = $event)),
      disable: _ctx.disable,
      label: 
        _ctx.$t(
          _unref(ETelematicsMessagesKeys).BASE_ACCOUNT_NAME_INSTRUCTION_CONFIRMATION_TITLE
        )
      
    }, null, 8, ["modelValue", "disable", "label"]),
    _createVNode(_component_d_input, {
      ref_key: "nameControl",
      ref: nameControl,
      modelValue: accountNameModel.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((accountNameModel).value = $event)),
      disable: _ctx.disable,
      class: "drv-my-2 drv-form-control-adaptive",
      "lazy-rules": "",
      "label-slot": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
        _unref(maxLengthValidator)(
          100,
          _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
        ),
        _unref(minLengthValidator)(
          2,
          _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
        ),
      ]
    }, {
      label: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).BASE_ACCOUNT_NAME_INSTRUCTION_2_TITLE, {
            fieldName: _ctx.$t(currentText.value.fieldName),
          })), 1),
        (currentText.value.hint)
          ? (_openBlock(), _createBlock(_component_d_icon_tooltip, {
              key: 0,
              icon: icon,
              class: "info-icon drv-ml-1 drv-color-b400",
              "tooltip-anchor": "top end",
              "tooltip-self": "top start"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: _ctx.$t(currentText.value.hint)
                }, null, 8, _hoisted_3)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "disable", "rules"])
  ]))
}
}

})